<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :disable-initial-sort="true"
      :rows-per-page-items="[-1]"
      hide-actions
      class="elevation-1"
    >
      <template #headers="props">
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="[
            'column sortable px-2 py-0',
            sortOptions.descending ? 'desc' : 'asc',
            header.value === sortOptions.sortBy ? 'active' : '',
            header.align === 'center' ? 'text-xs-center' : '',
            header.align === 'right' ? 'text-xs-right' : '',
            header.align === 'left' ? 'text-xs-left' : '',
          ]"
          :aria-sort="header.sortable ? '' : 'none'"
          @click="changeSort(header)"
          class="align-center"
        >
          {{ header.text }}
          <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
        </th>
      </template>

      <template v-slot:items="props">
        <tr>
          <td v-if="isLoginLp()" class="align-left">
            {{ props.item.advertiserName }}
          </td>
          <td class="align-left">{{ props.item.name }}</td>
          <td class="align-left">
            {{ getStatus(props.item) }}
            <v-tooltip v-if="props.item.isRunning" top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="primary">info</v-icon>
              </template>
              <span>
                現在、シミュレーションを実施中です。<br />完了後メールにて送付いたします。
              </span>
            </v-tooltip>
          </td>
          <td class="align-center">{{ props.item.updatedTime }}</td>
          <td class="align-center">
            <v-tooltip v-if="props.item.isRunning" top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-btn small disabled class="min-width">共有</v-btn>
                </span>
              </template>
              <span>
                現在シミュレーションを実施中のため、共有機能はご利用いただけません。<br />
                シミュレーション完了後ご利用いただけます。
              </span>
            </v-tooltip>
            <ButtonShare
              v-if="!props.item.isReadOnly || props.item.isRunning === false"
              @click="onSimulationButtonClicked(props.item)"
              class="padding-button"
            />
          </td>
          <td class="align-center" style="display: flex">
            <ButtonEdit
              :simulationPlanId="props.item.id"
              :isReadOnly="props.item.isReadOnly"
            />
            <ButtonDelete
              @onDeleted="refreshList"
              :simulation-plan="props.item"
              class="padding-button"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <SimulationUrlLinkModal
      v-if="displayUrlLinkModal"
      :visible="displayUrlLinkModal"
      @cancel="cancel"
      :hash-id="targetSimulation.hashId"
      :simulation-id="targetSimulation.id"
      :advertiser-id="targetSimulation.advertiserId"
      :agency-id="agencyId"
      :is-login-l-p="isLoginLp"
    />
  </div>
</template>

<script>
import ButtonEdit from '@/components/Shared/Simulation/SimulationListButtonEdit'
import ButtonShare from '@/components/Shared/Simulation/SimulationListButtonShare'
import ButtonDelete from '@/components/Shared/Simulation/SimulationListButtonDelete'
import SimulationUrlLinkModal from '@/components/Shared/Simulation/SimulationUrlLinkModal'

export default {
  name: 'SimulationList',
  components: {
    ButtonEdit,
    ButtonShare,
    ButtonDelete,
    SimulationUrlLinkModal,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    sortOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      displayUrlLinkModal: false,
      targetSimulation: () => {},
      agencyId: null,
    }
  },
  computed: {
    headers() {
      if (this.isLoginLp()) {
        return [
          { text: '広告主', value: 'advertiserName' },
          { text: 'シミュレーション名', value: 'name', sortable: true },
          { text: 'ステータス', value: 'status' },
          { text: '更新日時', value: 'updated_time', sortable: true },
          { text: '共有', sortable: false, align: 'center' },
          { text: '操作', sortable: false, align: 'center' },
        ]
      }
      // LoginLp出ない場合は広告主のheaderを表示しない
      return [
        { text: 'シミュレーション名', value: 'name' },
        { text: 'ステータス', value: 'status', sortable: false },
        { text: '更新日時', value: 'updated_time', sortable: true },
        { text: '共有', sortable: false, align: 'center' },
        { text: '操作', sortable: false, align: 'center' },
      ]
    },
  },
  created() {
    this.agencyId = Number(this.$route.params.agencyId) | null
  },
  methods: {
    isLoginLp() {
      if (this.$route.name === 'LoginLpSimulation') return true
      return false
    },
    onSimulationButtonClicked(targetSimulation) {
      this.displayUrlLinkModal = true
      this.targetSimulation = targetSimulation
    },
    cancel() {
      this.displayUrlLinkModal = false
    },
    refreshList() {
      this.$emit('refresh')
    },
    changeSort(header) {
      if (!header.sortable) return
      const column = header.value
      const newSortOptions = {
        ...this.sortOptions,
      }
      if (newSortOptions.sortBy === column) {
        newSortOptions.descending = !newSortOptions.descending
      } else {
        newSortOptions.sortBy = column
        newSortOptions.descending = false
      }
      this.$emit('changeSort', newSortOptions)
    },
    getStatus(item) {
      if (item.isRunning === undefined && item.isReadOnly) return `読み取り専用`
      if (item.isRunning && item.isReadOnly) return `読み取り専用（集計中）`
      if (item.isReadOnly) return '読み取り専用（結果取得済み）'
      return '編集可能'
    },
  },
}
</script>

<style scoped>
.padding-button {
  padding-left: 12px;
}
.align-center {
  text-align: center;
}
.min-width {
  min-width: 60px;
}
</style>
